import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });

export const getSports = () => api.get("/sports").then((r) => r.data);
export const getRankings = (sport, division) =>
  api
    .get(`/rankings/${sport}`, { params: division ? { division } : {} })
    .then((r) => r.data);
export const getTeam = (slug) => api.get(`/teams/${slug}`).then((r) => r.data);
export const getSyncStatus = () => api.get(`/sync-status`).then((r) => r.data);
export const triggerSync = () => api.post(`/sync`).then((r) => r.data);
export const getNews = (sport, division) =>
  api
    .get(`/news`, { params: { ...(sport ? { sport } : {}), ...(division ? { division } : {}) } })
    .then((r) => r.data);
export const getHeadline = () => api.get(`/news/headline`).then((r) => r.data);
